import React, { useEffect, useState } from 'react';
import { Link, Outlet } from 'react-router-dom';
import { GetTransactionStatus, LinkTerminal, PaymentRequest, UnLinkTerminal } from '../../Redux/Features/OnlineAPI/OnlineAPISlice';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

import { Modal, Button, Form, InputGroup, ToggleButton, ToggleButtonGroup } from 'react-bootstrap';

import smpc_popcorn from './ConcessionImages/PopCorn/smpc.png'
import mdpc_popcorn from './ConcessionImages/PopCorn/mdpc.png'
import lgpc_popcorn from './ConcessionImages/PopCorn/lgpc.png'
import rflpc_popcorn from './ConcessionImages/PopCorn/rflpc.png'

import food_churros from './ConcessionImages/Food/churros.png'
import food_hotdog from './ConcessionImages/Food/hotdog.png'
import food_nachos from './ConcessionImages/Food/nachos.png'
import food_pretzel from './ConcessionImages/Food/pretzel.png'
import food_xtracheese from './ConcessionImages/Food/xtracheese.png'

import drinks_aj from './ConcessionImages/Drinks/aj.png'
import drinks_kddr from './ConcessionImages/Drinks/kddr.png'
import drinks_kdicee from './ConcessionImages/Drinks/kdicee.png'
import drinks_lgdr from './ConcessionImages/Drinks/lgdr.png'
import drinks_lgicee from './ConcessionImages/Drinks/lgicee.png'
import drinks_lgwtr from './ConcessionImages/Drinks/lgwtr.png'
import drinks_mddr from './ConcessionImages/Drinks/mddr.png'
import drinks_smdr from './ConcessionImages/Drinks/smdr.png'

import icecream_dibscrunch from './ConcessionImages/IceCream/dibscrunch.png'
import icecream_sandwich from './ConcessionImages/IceCream/sandwich.png'

import candy_fruit from './ConcessionImages/CandyLG/fruitsnacks.png'
import candy_mpeanuts from './ConcessionImages/CandyLG/m_mpeanuts.png'
import candy_staw from './ConcessionImages/CandyLG/sourparchwatermelon.png'
import candy_redvines from './ConcessionImages/CandyLG/redvines.png'

import approved from "../Simulator/VirtualTerminal/Screens/success-icon.svg"
import declinded from "../Simulator/VirtualTerminal/Screens/declined-icon.svg"

function TerminalModal(props) {
    const [connectionId, setConnectionId] = useState('');
    const [terminalId, setTerminalId] = useState('');
    const [registrationCode, setRegistrationCode] = useState('');
    const [error, setError] = useState('');

    const [linking, setLinking] = useState(false);
    const [isActualTerminal, setIsActualTerminal] = useState(false);
    const [useDefault, setUseDefault] = useState(false);

    const handleChangeIsActualTerminal = () => {
        setIsActualTerminal(!isActualTerminal);
    };

    const handleChange = () => {
        setLinking(!linking);
    };

    const justClose = () => {
        props.onHide();
    }

    const handleSubmit = () => {
        // Close the modal
        // Validate if terminalId is a 6-digit number
        if (linking) {
            if (/^\d{6}$/.test(registrationCode)) {
                // Clear the input field
                setRegistrationCode('');
                // Close the modal
                props.onHide();
                // Clear any previous error message
                setError('');
                // Here you can perform any action with the terminalId
                props.onExcecuteProcess({
                    terminalId: terminalId,
                    registrationCode: registrationCode,
                    linking: linking,
                })
            } else {
                // Show error message if the entered value is not a 6-digit number
                setError('Registration code must be a 6-digit number.');
            }
        } else {
            // Here you can perform any action with the terminalId
            props.onExcecuteProcess({
                terminalId: terminalId,
                registrationCode: registrationCode,
                linking: linking,
            })
        }
    };

    const useThisTermial = () => {
        var value = !useDefault
        setUseDefault(value);
        if (value) {
            props.onUseDefaultTerminal(terminalId)
        } else {
            props.onUseDefaultTerminal('')
        }
    }

    useEffect(() => {
        if (!isActualTerminal) {
            props.onUseConnectionId(connectionId)
        }
    }, [isActualTerminal, connectionId])

    return (
        <Modal {...props} centered>
            <Modal.Header closeButton>
                <Modal.Title>Register Westpay Terminal</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group controlId="formTerminalId">
                        <Form.Label>Terminal ID:</Form.Label>
                        <InputGroup>
                            <Form.Control
                                type="text"
                                placeholder="Enter Terminal ID"
                                value={terminalId}
                                disabled={useDefault}
                                onChange={(e) => setTerminalId(e.target.value)}
                            />
                        </InputGroup>
                    </Form.Group>
                    <div style={{ marginBottom: '10px' }}></div>
                    <Form.Check
                        type="switch"
                        id="custom-switch"
                        label={useDefault && <span style={{ color: '#61C554' }}>Used default</span>}
                        checked={useDefault}
                        disabled={terminalId === ""}
                        onChange={useThisTermial}
                    />
                    <div style={{ marginBottom: '10px', marginTop: '5px', padding: '5px' }}><span >Use default skip terminal linking</span></div>

                    {!useDefault &&
                        <>
                            <hr />
                            <h6>Terminal Linking and Unlinking</h6>
                            <Form.Group controlId="formTerminalId">
                                <Form.Check
                                    type="switch"
                                    id="custom-switch"
                                    label={linking ? <span style={{ color: '#61C554' }}>Linking</span> : <span style={{ color: '#ED6A5E' }}>Un-Linking</span>}
                                    checked={linking}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                            {/* Add space between form groups */}
                            <div style={{ marginBottom: '20px' }}></div>
                            {linking &&
                                <Form.Group controlId="formRegistrationCode">
                                    <Form.Label>Registration Code:</Form.Label>
                                    <Form.Control
                                        type="number"
                                        placeholder="Enter 6-digit Registration Code"
                                        value={registrationCode}
                                        onChange={(e) => setRegistrationCode(e.target.value)}
                                    />
                                    <Form.Text className="text-danger">{error}</Form.Text>
                                </Form.Group>
                            }
                        </>
                    }
                    <>
                        <hr />
                        <h6>Simulation</h6>
                        <Form.Group controlId="formTerminalId">
                            <Form.Check
                                type="switch"
                                id="custom-switch"
                                label={isActualTerminal ? <span>Actual Terminal</span> : <span>Simulator</span>}
                                checked={isActualTerminal}
                                onChange={handleChangeIsActualTerminal}
                            />
                        </Form.Group>
                        {/* Add space between form groups */}
                        <div style={{ marginBottom: '20px' }}></div>
                        {!isActualTerminal &&
                            <>
                                <Form.Group controlId="formConnectionId">
                                    <Form.Label>Enter ConnectionID from the simulation portal when you do simulations:</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter ConnectionID"
                                        value={connectionId}
                                        onChange={(e) => setConnectionId(e.target.value)}
                                    />
                                </Form.Group>
                            </>
                        }
                    </>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                {
                    !useDefault &&
                    <Button variant={linking ? "primary" : "danger"} onClick={handleSubmit}>{linking ? 'Link' : 'Unlink'}</Button>
                }
                {
                    useDefault &&
                    <Button variant="primary" onClick={justClose}>Ok</Button>
                }
            </Modal.Footer>
        </Modal>
    );
}

const SampleEcr = props => {
    const [total, setTotal] = useState(0);
    const [items, setItems] = useState([]);
    const [payNowDisabled, setPayNowDisabled] = useState(true);
    const [onlineAPIRef, setOnlineAPIRef] = useState(null);
    const [transactionStatus, setTransactionStatus] = useState(null);
    const [loading, setLoading] = useState(false)
    const [loadingMessage, setLoadingMessage] = useState(null);
    const [isApproved, setIsApproved] = useState(false)
    const [isDeclined, setIsDeclined] = useState(false)
    const [terminalId, setTerminalId] = useState('')
    const [connectionId, setConnectionId] = useState(null)

    const [showModal, setShowModal] = useState(false);

    const dispatch = useDispatch();

    const addItem = (product, price) => {
        const itemIndex = items.findIndex((item) => item.product === product);

        if (itemIndex !== -1) {
            // If the product is already in the cart, update the quantity and total
            const updatedItems = [...items];
            updatedItems[itemIndex].count += 1; // Increase the count
            updatedItems[itemIndex].price += price; // Update the price for that item
            setItems(updatedItems);
        } else {
            // If the product is not in the cart, add it as a new item
            const updatedItems = [...items, { product, price, count: 1 }];
            setItems(updatedItems);
        }

        const newTotal = total + price;
        setTotal(newTotal);
        setPayNowDisabled(false);
    };

    const onExcecuteProcess = (result) => {
        if (result) {
            const { terminalId, registrationCode, linking } = result
            if (linking) {
                var payload = {
                    "terminalId": terminalId,
                    "registrationCode": registrationCode
                }
                linkTerminal(payload, terminalId)
            } else {
                var payload = {
                    "terminalId": terminalId
                }
                unlinkTerminal(payload, terminalId)
            }
        }
    }

    const linkTerminal = (payload, terminalId) => {
        setLoading(true);
        setLoadingMessage("POS is linking with Terminal " + terminalId)
        dispatch(LinkTerminal(payload, function (response, success) {
            if (response != null && (response.status == 201 || response.status == 200)) {
                setTerminalId(terminalId);
                toast.success("Terminal linking successfully done.")
            } else {
                setTerminalId('');
                toast.error(response?.message)
            }
            setLoading(false);
            setLoadingMessage("")
        }, connectionId));
    };

    const unlinkTerminal = (payload, terminalId) => {
        setLoading(true);
        setLoadingMessage("POS is un-linking from current Terminal " + terminalId)
        dispatch(UnLinkTerminal(payload, function (response, success) {
            if (response != null && (response.status == 201 || response.status == 200)) {
                toast.success("Terminal un-linking successfully done.")
                setTerminalId('');
            } else {
                toast.error(response?.message)
            }
            setLoading(false);
            setLoadingMessage("")
        }, connectionId));
    };


    const payNow = () => {
        var payload = {
            "amount": total.toFixed(2),
            "currencyCode": 752,
            "terminalId": terminalId,
            "paymentMethod": ""
        }
        setLoading(true);
        setLoadingMessage("Waiting for payment confirmation..")
        dispatch(PaymentRequest(payload, function (response, success) {
            if (response != null && response.status == 201) {
                setOnlineAPIRef(response.data.onlineAPIRefId)
                checkTransactionStatus(response.data.onlineAPIRefId)
            } else {
                setIsDeclined(true)
                toast.error(response?.message)
                setTimeout(() => {
                    setIsDeclined(false);
                }, 2000)
                setItems([])
            }
        }, connectionId));
    };

    const checkTransactionStatus = (onlineAPIRef) => {
        try {
            dispatch(GetTransactionStatus(onlineAPIRef, function (response, success) {
                if (response.status === 200 && response.data.transactionStatus !== 14) {
                    setLoading(false);
                    setTransactionStatus(response.data.transactionStatus);
                    setLoading(false);
                    setLoadingMessage("")
                    if (response.data.transactionStatus == 0) {
                        setIsApproved(true);
                        setTimeout(() => {
                            setIsApproved(false);
                        }, 2000)
                    } else {
                        setIsDeclined(true)
                        setTimeout(() => {
                            setIsDeclined(false);
                        }, 2000)
                    }
                    setItems([]);
                    setTotal(0);
                } else if (response.data.transactionStatus === 14) {
                    // Set a timeout to retry after some time if the status is 14
                    setTimeout(checkTransactionStatus(onlineAPIRef), 2000); // Retry after 2 seconds
                }
            }, connectionId))
        } catch (err) {
            setLoading(false);
            setLoadingMessage("")
        }
    };

    return (
        <div className="App">
            <div className="topbar">
                <p className="logo">Cinema POS</p>
                <button type="button" class="btn btn-primary" aria-label="Delete" style={{ margin: '5px' }} onClick={() => setShowModal(true)}>
                    <span class="fa fa-gear fa-lg" aria-hidden="true"></span>
                </button>
            </div>
            <div id="ecr-container">
                {isApproved && <div className='ecr-output-message'>
                    <span>Payment Successful</span>
                    <img src={approved} alt='close' layout="fill" objectFit="fill"></img>
                </div>}
                {isDeclined && <div className='ecr-output-message'>
                    <span>Payment Declined</span>
                    <img src={declinded} alt='close' layout="fill" objectFit="fill"></img>
                </div>}
                {loading && <div className='ecr-output-message loading-message'>
                    <span>{loadingMessage}</span>
                    <img src='/assets/images/loading.svg' alt='close' layout="fill" objectFit="fill"></img>
                </div>}
                <div id="left">
                    <div className="product-container">
                        <div className='row'>
                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                <a onClick={() => addItem('Popcorn Small', 10)}>
                                    <div className="product-box" style={{ backgroundColor: '#CEDBDB' }}>
                                        <div className="product-name">Popcorn Small</div>
                                        <div className="price">Price: 10 kr</div>
                                        <img src={smpc_popcorn}></img>
                                    </div>
                                </a>
                            </div>
                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                <a onClick={() => addItem('Medium Popcorn', 20)}>
                                    <div className="product-box" style={{ backgroundColor: '#E3CBEC' }}>
                                        <div className="product-name">Popcorn Medium</div>
                                        <div className="price">Price: 20 kr</div>
                                        <img src={mdpc_popcorn}></img>
                                    </div>
                                </a>
                            </div>
                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                <a onClick={() => addItem('Popcorn Large', 30)}>
                                    <div className="product-box" style={{ backgroundColor: '#C0DAE9' }}>
                                        <div className="product-name">Popcorn Large</div>
                                        <div className="price">Price: 30 kr</div>
                                        <img src={lgpc_popcorn}></img>
                                    </div>
                                </a>
                            </div>
                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                <a onClick={() => addItem('Refill', 5)}>
                                    <div className="product-box" style={{ backgroundColor: '#C0DAE9' }}>
                                        <div className="product-name">Refill PopCorn</div>
                                        <div className="price">Price: 5 kr</div>
                                        <img src={rflpc_popcorn}></img>
                                    </div>
                                </a>
                            </div>
                        {/* </div> */}
                        {/* <div className='row col-xl-12 col-lg-12 col-md-12'> */}
                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                <a onClick={() => addItem('Churros', 40)}>
                                    <div className="product-box" style={{ backgroundColor: '#E3CBEC' }}>
                                        <div className="product-name">Churros</div>
                                        <div className="price">Price: 40 kr</div>
                                        <img src={food_churros}></img>
                                    </div>
                                </a>
                            </div>
                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                <a onClick={() => addItem('Hot Dog', 50)}>
                                    <div className="product-box" style={{ backgroundColor: '#C0DAE9' }}>
                                        <div className="product-name">Hot Dog</div>
                                        <div className="price">Price: 50 kr</div>
                                        <img src={food_hotdog}></img>
                                    </div>
                                </a>
                            </div>
                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                <a onClick={() => addItem('Hot Dog', 50)}>
                                    <div className="product-box" style={{ backgroundColor: '#C0DAE9' }}>
                                        <div className="product-name">Hot Dog</div>
                                        <div className="price">Price: 50 kr</div>
                                        <img src={food_hotdog}></img>
                                    </div>
                                </a>
                            </div>
                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                <a onClick={() => addItem('Nachos', 25)}>
                                    <div className="product-box" style={{ backgroundColor: '#C0DAE9' }}>
                                        <div className="product-name">Nachos</div>
                                        <div className="price">Price: 25 kr</div>
                                        <img src={food_nachos}></img>
                                    </div>
                                </a>
                            </div>
                        {/* </div> */}
                        {/* <div className='row col-xl-12 col-lg-12 col-md-12'> */}
                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                <a onClick={() => addItem('Ice Cream Dibs', 10)}>
                                    <div className="product-box" style={{ backgroundColor: '#CEDBDB' }}>
                                        <div className="product-name">Ice Cream Dibs</div>
                                        <div className="price">Price: 10 kr</div>
                                        <img src={icecream_dibscrunch}></img>
                                    </div>
                                </a>
                            </div>
                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                <a onClick={() => addItem('Icecream Sandwich', 50)}>
                                    <div className="product-box" style={{ backgroundColor: '#E3CBEC' }}>
                                        <div className="product-name">Icecream Sandwich</div>
                                        <div className="price">Price: 50 kr</div>
                                        <img src={icecream_sandwich}></img>
                                    </div>
                                </a>
                            </div>
                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                <a onClick={() => addItem('Nachos', 25)}>
                                    <div className="product-box" style={{ backgroundColor: '#C0DAE9' }}>
                                        <div className="product-name">Nachos</div>
                                        <div className="price">Price: 25 kr</div>
                                        <img src={food_nachos}></img>
                                    </div>
                                </a>
                            </div>
                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                <a onClick={() => addItem('Pretzel Crunch', 60)}>
                                    <div className="product-box" style={{ backgroundColor: '#C0DAE9' }}>
                                        <div className="product-name">Pretzel Crunch</div>
                                        <div className="price">Price: 60 kr</div>
                                        <img src={food_pretzel}></img>
                                    </div>
                                </a>
                            </div>
                        {/* </div> */}
                        {/* <div className='row col-xl-12 col-lg-12 col-md-12'> */}
                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                <a onClick={() => addItem('Apple Juice', 30)}>
                                    <div className="product-box" style={{ backgroundColor: '#CEDBDB' }}>
                                        <div className="product-name">Apple Juice</div>
                                        <div className="price">Price: 30 kr</div>
                                        <img src={drinks_aj}></img>
                                    </div>
                                </a>
                            </div>
                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                <a onClick={() => addItem('CocaCola', 20)}>
                                    <div className="product-box" style={{ backgroundColor: '#E3CBEC' }}>
                                        <div className="product-name">CocaCola</div>
                                        <div className="price">Price: 20 kr</div>
                                        <img src={drinks_kddr}></img>
                                    </div>
                                </a>
                            </div>
                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                <a onClick={() => addItem('Icee', 10)}>
                                    <div className="product-box" style={{ backgroundColor: '#C0DAE9' }}>
                                        <div className="product-name">Ice</div>
                                        <div className="price">Price: 10 kr</div>
                                        <img src={drinks_kdicee}></img>
                                    </div>
                                </a>
                            </div>
                        {/* </div> */}
                        {/* <div className='row col-xl-12 col-lg-12 col-md-12'> */}
                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                <a onClick={() => addItem('CocaCola Large', 30)}>
                                    <div className="product-box" style={{ backgroundColor: '#C0DAE9' }}>
                                        <div className="product-name">CocaCola Large</div>
                                        <div className="price">Price: 30 kr</div>
                                        <img src={drinks_lgdr}></img>
                                    </div>
                                </a>
                            </div>
                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                <a onClick={() => addItem('Icee Large', 20)}>
                                    <div className="product-box" style={{ backgroundColor: '#CEDBDB' }}>
                                        <div className="product-name">Icee Large</div>
                                        <div className="price">Price: 20 kr</div>
                                        <img src={drinks_lgicee}></img>
                                    </div>
                                </a>
                            </div>
                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                <a onClick={() => addItem('Dasani Large', 25)}>
                                    <div className="product-box" style={{ backgroundColor: '#CEDBDB' }}>
                                        <div className="product-name">Dasani Large</div>
                                        <div className="price">Price: 25 kr</div>
                                        <img src={drinks_lgwtr}></img>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="right">
                    {terminalId === '' && <label className="text-danger" style={{ fontWeight: 'bold', marginLeft: '15px', marginBottom: '15px' }}>Westpay POS is currently not linked with the Terminal ID.</label>}
                    <div style={{ overflow: 'scroll' }}>
                        <table id="orderTable">
                            <thead>
                            </thead>
                            <tbody>
                                {items.map((item, index) => (
                                    <tr key={index} style={{ fontSize: 'large' }}>
                                        <td style={{ fontWeight: 'bold' }}>{item.count}</td>
                                        <td>{item.product}</td>
                                        <td style={{ fontWeight: 'bold' }}>{item.price} kr</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div>
                        <button id="payNowButton" onClick={payNow} disabled={payNowDisabled || terminalId === ''}>
                            {payNowDisabled ? 'Add products' : 'To Pay: ' + total + ' kr'}
                        </button>
                    </div>
                </div>
            </div>
            <TerminalModal
                show={showModal}
                onUseDefaultTerminal={setTerminalId}
                onUseConnectionId={setConnectionId}
                onExcecuteProcess={onExcecuteProcess}
                onHide={() => setShowModal(false)}
            />
        </div>
    );
}
export default SampleEcr;